import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { dateDaysAgo, dateHoursAgo } from '../chart.date';
import { LineChartResultData } from './line-chart';
import { LineChart, LineChartData } from './line-chart';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LineChartService {
  constructor(private translate: TranslateService) {}

  translateChartLabel(results: LineChart): Observable<string[]> {
    return this.translate.get([results.labelAll, results.labelAnswered]);
  }

  checkEmpty(results: LineChart) {
    return (
      (!results.data && results.data.all.length) ||
      results.data.all.filter(el => el.count === 0).length === results.data.all.length
    );
  }

  prepareChartOnEmptyData(labels: any): any {
    const chartData = { all: [], answered: [] };
    const data = { all: [1, 2, 5, 8, 12, 9, 16, 16, 17, 13, 11, 4, 6, 4, 5, 4, 3, 5, 7, 6, 10, 13] };

    data.all.forEach((el, index) => {
      chartData.all.push({
        date: dateDaysAgo(data.all.length - (index + 1)),
        count: data.all[index] * 2
      });
      chartData.answered.push({
        date: dateDaysAgo(data.all.length - (index + 1)),
        count: data.all[index]
      });
    });
    return { data: chartData, label: labels.all };
  }

  updateChartXLabels(lineChartLabels: any, charts) {
    // because chart.js not update labels
    if (charts && charts.last && charts.last.chart) {
      charts.last.chart.config.data.labels = lineChartLabels;
    }

    return lineChartLabels;
  }

  prepareChart(result: LineChart, labels): any[] {
    if (!result.data.all) {
      return [
        {
          data: result.data.all.map(el => ({
            x: el.date,
            y: el.count
          })),
          label: labels.all
        }
      ];
    }
    return [
      {
        data: result.data.all.map(el => ({
          x: el.date,
          y: el.count
        })),
        label: labels.all
      },
      {
        data: result.data.answered.map(el => ({
          x: el.date,
          y: el.count
        })),
        label: labels.answered
      }
    ];
  }
}
